import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import moment from 'moment';


export default function HorizontalTimeline(props:any) {
    const[times,setTimes]=React.useState<any>([]);
    React.useEffect(()=>{
        let timeSteps=[];
        if(props.type){
            let mainChef = props?.record?.cooks?.filter((cook: any) => cook?.type === "MAIN_CHEF")[0];
            let orderPayements = props?.record?.orders?.map((order: any) => {
                return {
                    name: order?.orderSummary,
                    time: order?.payment?.razorpayOrder?.paymentDate
                }
            });

            console.log(mainChef);
            orderPayements.map((order: any)=> {
                if(order?.time){
                    timeSteps.push([order?.name, moment(order?.time).format("DD MMM YYYY hh:mm A"), moment(order?.time).valueOf()])
                }
                return ''
            })
            if(props?.record?.createdAt){
                timeSteps.push(["createdAt", moment(props?.record?.createdAt).format("DD MMM YYYY hh:mm A"), moment(props?.record?.createdAt).valueOf()])
            }
            if(props?.record?.date && props?.record?.time){
                const isBBD = props?.record?.bookingType === "BOOK_BY_DISH";
                const cookingMins = isBBD ? Number(props?.record?.cookingTime ?? 0) : 0;
                const baseMoment = moment(props?.record?.date + " " + props?.record?.time, ["YYYY-MM-DD hh:mm A", "YYYY-MM-DD h:mm A", "YYYY-MM-DD HH:mm"]);
                const servingMoment = baseMoment.clone().add(cookingMins, "minutes");
                const servingTimestamp = servingMoment.valueOf();
                const servingDisplay = moment(props?.record?.date).format("DD MMM YYYY") + " " + servingMoment.format("hh:mm A");
                timeSteps.push(["Serving Time", servingDisplay, servingTimestamp])
            }
            if(mainChef?.details?.preCheckedInAt){
                timeSteps.push(["Pre CheckIn", moment(mainChef?.details?.preCheckedInAt).format("DD MMM YYYY hh:mm A"), moment(mainChef?.details?.preCheckedInAt).valueOf()])
            }
            if(mainChef?.details?.checkInTime){
                timeSteps.push(["Check-In", moment(mainChef?.details?.checkInTime).format("DD MMM YYYY hh:mm A"), moment(mainChef?.details?.checkInTime).valueOf()])
            }
            if(mainChef?.details?.checkOutTime){
                timeSteps.push(["Check-Out", moment(mainChef?.details?.checkOutTime).format("DD MMM YYYY hh:mm A"), moment(mainChef?.details?.checkOutTime).valueOf()])
            }
            if(props?.record?.chefArrivalTime){
                const chefArrivalTimestamp = moment(props?.record?.date + " " + props?.record?.chefArrivalTime, ["YYYY-MM-DD hh:mm A", "YYYY-MM-DD HH:mm"]).valueOf();
                timeSteps.push(["Chef Arrival Time", moment(props?.record?.date).format("DD MMM YYYY")+" "+props?.record?.chefArrivalTime, chefArrivalTimestamp])
            }
            if(props?.record?.cancelledAt){
                timeSteps.push(["Cancelled At", moment(props?.record?.cancelledAt).format("DD MMM YYYY hh:mm A"), moment(props?.record?.cancelledAt).valueOf()])
            }
        }
        else{
            if(props?.record?.createdAt){
                timeSteps.push(["createdAt", moment(props?.record?.createdAt).format("DD MMM YYYY hh:mm A"), moment(props?.record?.createdAt).valueOf()])
            }
            if(props?.record?.allocatedAt){
                timeSteps.push(["Allocated At", moment(props?.record?.allocatedAt).format("DD MMM YYYY hh:mm A"), moment(props?.record?.allocatedAt).valueOf()])
            }
            if(props?.record?.date&&props?.record?.time){
                const visitTimestamp = moment(props?.record?.date + " " + props?.record?.time, ["YYYY-MM-DD hh:mm A", "YYYY-MM-DD HH:mm"]).valueOf();
                timeSteps.push(["Visit Time", moment(props?.record?.date).format("DD MMM YYYY")+" "+props?.record?.time, visitTimestamp])
            }
            if(props?.record?.checkInTime){
                timeSteps.push(["Check-In", moment(props?.record?.checkInTime).format("DD MMM YYYY hh:mm A"), moment(props?.record?.checkInTime).valueOf()])
            }
            if(props?.record?.preCheckedInAt){
                timeSteps.push(["Pre-Check In", moment(props?.record?.preCheckedInAt).format("DD MMM YYYY hh:mm A"), moment(props?.record?.preCheckedInAt).valueOf()])
            }
            if(props?.record?.checkOutTime){
                timeSteps.push(["Check-out", moment(props?.record?.checkOutTime).format("DD MMM YYYY hh:mm A"), moment(props?.record?.checkOutTime).valueOf()])
            }
            if(props?.record?.cancelledAt){
                timeSteps.push(["Cancelled At", moment(props?.record?.cancelledAt).format("DD MMM YYYY hh:mm A"), moment(props?.record?.cancelledAt).valueOf()])
            }
        }
        timeSteps.sort((a:any, b:any) => a[2] - b[2]);
        setTimes(timeSteps);
    },[props, props.type])
  return (
    <Box sx={{ width: '100%' }}>
        {
            times&&times.length>0?
            <Stepper alternativeLabel activeStep={times?.length}>
                {times?.map((label:any) => (
                <Step key={label}>
                    <StepLabel>
                        <Box display={"flex"} flexDirection={"column"} gap={0.5}>
                            <Box fontWeight="bold">{label[0]}</Box>
                            <Box sx={label[0]==="Cancelled At" ? {color:"red"} : (label[0]==="Visit Time" || label[0]==="Serving Time") ?{color:"green"}:{}}>{label[1]}</Box>
                        </Box>    
                    </StepLabel>
                </Step>
                ))}
            </Stepper>:
          <></>
        } 
    </Box>
  );
}
